'use client'

import { useEffect } from 'react'

import { Router } from 'next/router'
import posthog from 'posthog-js'
import { PostHogProvider as PHProvider } from 'posthog-js/react'
import { Environment } from 'utils/env'
import { getEnvironmentByDomain } from 'utils/env'
import { getLocalFeatureFlags } from 'utils/featureFlag/localFeatureFlags'
import { beforeSend } from 'utils/posthog'

export function PostHogProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    const env = getEnvironmentByDomain(window.location.hostname)
    if (env === Environment.Local) {
      posthog.init('local-dev', {
        api_host: 'https://localhost',
        bootstrap: {
          featureFlags: getLocalFeatureFlags()
        },
        opt_out_capturing_by_default: true,
        disable_session_recording: true
      })

      return
    }

    if (env === Environment.Demo) {
      // eslint-disable-next-line alternative/no-invalid-env-usage
      posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY as string, {
        api_host:
          // eslint-disable-next-line alternative/no-invalid-env-usage
          process.env.NEXT_PUBLIC_POSTHOG_HOST || 'https://us.i.posthog.com',
        person_profiles: 'never',
        disable_session_recording: true
      })
      posthog.register({
        // eslint-disable-next-line alternative/no-invalid-env-usage
        $release: process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA
      })

      return
    }

    // eslint-disable-next-line alternative/no-invalid-env-usage
    posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY as string, {
      api_host:
        // eslint-disable-next-line alternative/no-invalid-env-usage
        process.env.NEXT_PUBLIC_POSTHOG_HOST || 'https://us.i.posthog.com',
      person_profiles: 'identified_only',
      disable_session_recording: true,
      capture_exceptions: {
        capture_console_errors: false,
        capture_unhandled_errors: false,
        capture_unhandled_rejections: false
      },
      before_send: beforeSend
    })
    posthog.register({
      // eslint-disable-next-line alternative/no-invalid-env-usage
      $release: process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA
    })

    const handleRouteChange = () => posthog?.capture('$pageview')

    Router.events.on('routeChangeComplete', handleRouteChange)

    return () => {
      Router.events.off('routeChangeComplete', handleRouteChange)
    }
  }, [])

  return <PHProvider client={posthog}>{children}</PHProvider>
}
